import { WFAuth, WFAuthMiddleware, navigate } from "@xatom/core";
import { globalVars } from "../dashboard/globalVars";

// Initialize the WFAuth instance with user data, roles, and configuration
export const userAuth = new WFAuth<
  {
    userId: string;
    password: string;
  },
  "GUEST" | "USER",
  {}
>();

// Setting default role
// userAuth.setRole("GUEST");

export const setUser = (userId: string, password: string) => {
  userAuth.setUser({
    userId,
    password,
  });
  userAuth.setRole("USER");
  localStorage.setItem(globalVars.LSKeys.userPageSlug, password + userId);
};

export const getUser = () => {
  return {
    userPageSlug: localStorage.getItem(globalVars.LSKeys.userPageSlug),
  };
};

// On logout, sign out and navigate to the home page
export const logout = () => {
  localStorage.removeItem(globalVars.LSKeys.userToken);
  userAuth.logout();
  navigate(globalVars.pagesPaths.login);
};

// Setting up middleware for routes
export const userMiddleware = new WFAuthMiddleware(userAuth);
